import * as types from './company-tools-categories.types';
import * as constants from './company-tools-categories.constants';
import {
  ICompanyToolsCategory,
  ICompanyToolsCategoryCreateForm,
} from '../../../resource/company-tools-category/company-tools-category.types';

export const createCompanyToolsCategory = (
  companyToolsCategory: ICompanyToolsCategoryCreateForm,
): types.ICreateCompanyToolsCategory => ({
  type: constants.CREATE_COMPANY_TOOLS_CATEGORY,
  payload: companyToolsCategory,
});

export const updateCompanyToolsCategory = (
  companyToolsCategoryId: ICompanyToolsCategory['id'],
  companyToolsCategory: ICompanyToolsCategoryCreateForm,
): types.IUpdateCompanyToolsCategory => ({
  type: constants.UPDATE_COMPANY_TOOLS_CATEGORY,
  payload: {
    id: companyToolsCategoryId,
    data: companyToolsCategory,
  },
});

export const deleteCompanyToolsCategory = (
  companyToolsCategoryId: ICompanyToolsCategory['id'],
): types.IDeleteCompanyToolsCategory => ({
  type: constants.DELETE_COMPANY_TOOLS_CATEGORY,
  payload: { companyToolsCategoryId },
});

export const storeCompanyToolsCategories = (
  companyToolsCategories: ICompanyToolsCategory['id'][],
): types.IStoreCompanyToolsCategories => ({
  type: constants.STORE_COMPANY_TOOLS_CATEGORIES,
  payload: companyToolsCategories,
});

export const clearCompanyToolsCategories = (): types.IClearCompanyToolsCategories => ({
  type: constants.CLEAR_COMPANY_TOOLS_CATEGORIES,
});

export const storeIsFetched = (): types.IStoreIsFetched => ({
  type: constants.STORE_IS_FETCHED,
});

export const clearIsFetched = (): types.IClearIsFetched => ({
  type: constants.CLEAR_IS_FETCHED,
});
